if (!customElements.get('cart-tier-progress')) {
  class CartTierProgress extends HTMLElement {
    connectedCallback() {
      this._onCartUpdated = (e) => this._update(e.detail.cart.item_count);
      document.addEventListener('cart:updated', this._onCartUpdated);

      this._watchProductsContainer();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:updated', this._onCartUpdated);
      if (this._observer) this._observer.disconnect();
    }

    _watchProductsContainer() {
      const productsEl = document.querySelector('[data-products]');
      if (!productsEl) return;

      this._syncFromProductsEl(productsEl);

      this._observer = new MutationObserver(() => this._syncFromProductsEl(productsEl));
      this._observer.observe(productsEl, { childList: true });
    }

    _syncFromProductsEl(productsEl) {
      const cartItemsEl = productsEl.querySelector('[data-cart-subtotal]');
      if (!cartItemsEl) return;
      this._update(parseInt(cartItemsEl.dataset.count, 10) || 0);
    }

    // Mirrors the Liquid logic so the bar and badge stay in sync after
    // cart updates without needing the drawer to reopen.
    _update(itemCount) {
      if (itemCount === 0) {
        this.hidden = true;
        return;
      }
      this.hidden = false;

      const steps = Array.from(this.querySelectorAll('[data-step]'));
      const quantities = steps.map((step) => parseInt(step.dataset.qty, 10) || 0);
      const totalSteps = steps.length;

      let activeIndex = 0;
      quantities.forEach((qty, index) => {
        if (itemCount >= qty) {
          activeIndex = index + 1;
        }
      });

      let fillPct = 0;
      if (activeIndex > 0) {
        fillPct = activeIndex === totalSteps
          ? 100
          : ((activeIndex - 0.5) / totalSteps) * 100;
      }

      this.style.setProperty('--tier-progress-fill', fillPct.toFixed(2).replace(/\.00$/, '') + '%');

      steps.forEach((step, index) => {
        const stepIndex = index + 1;
        let status = 'upcoming';

        if (stepIndex < activeIndex) {
          status = 'passed';
        } else if (stepIndex === activeIndex) {
          status = 'active';
        }

        step.classList.remove('is-upcoming', 'is-active', 'is-passed');
        step.classList.add('is-' + status);
      });
    }
  }

  customElements.define('cart-tier-progress', CartTierProgress);
}
